<!--
 * @Descripttion: iframe组件
 * @Author: zenghua.wang
 * @Date: 2021-11-17 09:29:02
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 16:42:12
-->
<template>
  <div :class="setClass()" :style="styleSize" v-if="!option.hide">
    <iframe v-if="option.source" :src="option.source" :class="setClass('wrapper')" draggable="false"
      @load="loaded"></iframe>

    <!-- 占位符-->
    <div v-else class="drag-empty" :style="styleVisible" />
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import { setPx } from '@/dragComponents/utils'

export default {
  name: 'drag-iframe',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: this.category === 'report' ? this.width : setPx(this.width),
          height: setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleVisible() {
      return {
        display: this.disabled ? 'none' : 'block'
      }
    }
  },
  methods: {
    loaded() { }
  }
}
</script>
<style lang="scss" scoped>
.drag-iframe {
  box-sizing: border-box;

  &-wrapper {
    width: 100%;
    height: 100%;
    border: 0;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }

  :deep(.drag-empty:before) {
    content: "iframe内容占位";
  }
}
</style>

